function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDisabled = function SvgDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 210 210",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      strokeWidth: 23.0518,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    cx: 105.153,
    cy: 105.356,
    rx: 93.003,
    ry: 92.799,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.65592 .75483 -.73357 .67962 0 0)",
    d: "M66.449-24.967h163.823V2.579H66.449z"
  }));
};
export default SvgDisabled;